import React, { useState } from 'react'
import shield from '../images/shield.svg'
import hydra from '../images/hydra.svg'

export const ThemeContext = React.createContext()

//Sets up Super Secret Villain Mode
const ThemeProvider = props => {
	const [mode, setMode] = useState('shield')

	const changeMode = newMode => setMode(newMode)

	const { children } = props

	const value = { mode, changeMode }

	const style =
		mode === 'shield'
			? {
          background: `url(${shield}) center center no-repeat`,
          backgroundColor: '#151518'
			  }
			: {
          background: `url(${hydra}) center center no-repeat`,
          backgroundColor: '#360C10',
					fontFamily: 'Wallpoet'
      }
			
	return (
		<ThemeContext.Provider value={value}>
			<div style={style}>{children}</div>
		</ThemeContext.Provider>
	)
}

export default ThemeProvider
